import { useQuery } from '@tanstack/react-query';
import {
  Bar, CartesianGrid, ComposedChart, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis,
} from 'recharts';
import { dashboardApi } from '../../api/dashboard';

export function FinancialPhysical() {
  const { data, isLoading } = useQuery({
    queryKey: ['dashboard', 'financial-physical'],
    queryFn: dashboardApi.financialPhysical,
    refetchInterval: 60_000,
  });

  return (
    <div className="bg-white border border-cream-200 rounded-sm">
      <div className="px-5 py-4 border-b border-cream-100">
        <h3 className="serif-display text-base text-navy-800 font-medium accent-underline inline-block">
          Financial × Physical
        </h3>
        <p className="text-xs text-navy-800/60 mt-3">
          Subsidy disbursed (₹ Cr) vs. units verified · Top 8 mandals
        </p>
      </div>
      <div className="p-5 pt-3" style={{ height: 280 }}>
        {isLoading || !data ? (
          <div className="h-full bg-cream-100 rounded-sm animate-pulse" />
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart data={data} margin={{ top: 10, right: 10, bottom: 28, left: -10 }}>
              <CartesianGrid stroke="#F5F0E6" vertical={false} />
              <XAxis
                dataKey="mandal_name"
                tick={{ fontSize: 11, fill: '#5A5A5A', fontFamily: 'IBM Plex Sans' }}
                stroke="#D8CFBA"
              />
              <YAxis
                yAxisId="left"
                tick={{ fontSize: 10, fill: '#5A5A5A', fontFamily: 'IBM Plex Mono' }}
                tickFormatter={(v: number) => `₹${v}Cr`}
                axisLine={false}
                tickLine={false}
              />
              <YAxis
                yAxisId="right"
                orientation="right"
                tick={{ fontSize: 10, fill: '#5A5A5A', fontFamily: 'IBM Plex Mono' }}
                tickFormatter={(v: number) => `${(v / 1000).toFixed(1)}k`}
                axisLine={false}
                tickLine={false}
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: '#0A2540',
                  border: 'none',
                  borderRadius: 2,
                  color: 'white',
                  fontFamily: 'IBM Plex Sans',
                  fontSize: 12,
                }}
                labelStyle={{ color: 'white' }}
                itemStyle={{ color: 'white' }}
              />
              <Legend
                wrapperStyle={{ fontFamily: 'IBM Plex Sans', fontSize: 11, color: '#0A2540', paddingTop: 12 }}
                iconType="circle"
              />
              <Bar yAxisId="left"  dataKey="disbursed_cr"  name="Subsidy disbursed (₹ Cr)" fill="#0A2540" radius={[2, 2, 0, 0]} />
              <Bar yAxisId="right" dataKey="verified_units" name="Units verified"          fill="#E8740C" radius={[2, 2, 0, 0]} />
            </ComposedChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
}
